import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { PasswordValidators } from "../form/validator/password-validators";
import { HttpCustomerService } from "../services/http/customer.service";

export interface ChangePasswordFormValuesInterface {
  password: string
}

@Component({
    selector: 'gea-shop-confirm-email',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent {

  service: HttpCustomerService
  state: "edit" | "validating" | "success" | "fail"
  form: FormGroup
  fb: FormBuilder

  constructor(
    @Inject(HttpCustomerService) service: HttpCustomerService,
    private route: ActivatedRoute,
    fb: FormBuilder
  ) {
    this.service = service
    this.state = "edit"
    this.fb = fb

    this.form = this.fb.group({
      password: ["", { validators: PasswordValidators.defaultValidationConfig }],
      confirmPassword: ["", { validators: [Validators.required] }],
    }, {
      validators: PasswordValidators.matchValidator
    })
  }

  submit(formValues: ChangePasswordFormValuesInterface) {
    this.route.queryParams.subscribe(params => {
      if ("token" in params) {
        this.service.changePassword(params["token"], formValues.password).subscribe(
          response => {
            this.state = "success"
          },
          error => {
            this.state = "fail"
          }
        )
      }
    })
  }
}
